import { Link } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import { Initials } from '../initials';

import styles from './style.module.css';

// One patient in the clinician's list: initials, name, since when they are
// connected, how many tests wait for them, and how many submitted ones the
// clinician has not reviewed. The row opens the patient's page.
export function PatientRow({ patient }) {
  const { text, language } = useLanguage();
  const { id, firstName, lastName, connectedSince, openTests, toReview } = patient;
  const details = [
    text.connectedSince.replace('{date}', describe({ day: dayOf(connectedSince), language, short: true })),
    text.openTests.replace('{count}', openTests)
  ];

  let fresh = null;

  if (toReview > 0) {
    fresh = <span className={ styles.fresh }>{ text.newToReview.replace('{count}', toReview) }</span>;
  }

  return (
    <Link className={ styles.row } to={ `/patients/${ id }` }>
      <Initials firstName={ firstName } lastName={ lastName }/>

      <span className={ styles.lines }>
        <span className={ styles.name }>{ `${ firstName } ${ lastName }` }</span>
        <span className={ styles.detail }>{ details.join(' · ') }</span>
      </span>

      { fresh }

      <span className={ styles.chevron } aria-hidden='true'></span>
    </Link>
  );
}
